export const setAppointments = (state, payload) => {
  state.appointments = payload
}
